import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';

import Feature from '../Feature';

import ResponseRateIcon from './ResponseRateIcon';

import styles from './ResponseRateFeature.module.scss';

const RESPONSE_RATE_FEATURE = 'responseRateFeature';

const STATE_CONFIG = {
  4: {
    titleKey: 'property_show.book_now_card.response_rate.high.title',
    bodyKey: 'property_show.book_now_card.response_rate.high.body'
  },
  3: {
    titleKey: 'property_show.book_now_card.response_rate.medium.title',
    bodyKey: 'property_show.book_now_card.response_rate.medium.body'
  },
  2: {
    titleKey: 'property_show.book_now_card.response_rate.low.title',
    bodyKey: 'property_show.book_now_card.response_rate.low.body'
  }
};

const ResponseRateFeature = ({
  responseRateState,
  collapsed = true,
  onCollapsedChange = () => {}
}) => {
  const config = STATE_CONFIG[responseRateState];
  if (!config) return null;

  return (
    <Feature
      featureName={RESPONSE_RATE_FEATURE}
      collapsed={collapsed}
      onCollapsedChange={onCollapsedChange}
      renderIcon={() => <ResponseRateIcon state={responseRateState} />}
      headerKey={config.titleKey}
      renderBody={() => (
        <div className={styles['response-rate-body']}>
          <p className={styles['response-rate-body__description']}>
            {trans(config.bodyKey)}
          </p>
        </div>
      )}
    />
  );
};

ResponseRateFeature.propTypes = {
  responseRateState: PropTypes.oneOf([2, 3, 4]).isRequired,
  collapsed: PropTypes.bool,
  onCollapsedChange: PropTypes.func
};

export default ResponseRateFeature;
